import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
export function PublicHeader() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  return <header className="sticky top-0 z-50 bg-white border-b border-borderColor" data-id="element-253">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-254">
        <div className="flex justify-between items-center h-16 sm:h-20" data-id="element-255">
          <div className="flex items-center" data-id="element-256">
            <Link to="/" className="flex-shrink-0" data-id="element-257">
              <img src="https://cdn.magicpatterns.com/uploads/u4AKTM42BTBGHrLv1PiYxT/Logo_3.png" alt="LawVo" className="h-8 object-contain hidden sm:block" data-id="element-258" />
              <img src="https://cdn.magicpatterns.com/uploads/xxZvTa8VY3udNLg3cdpVcE/LawVo-logo-icon.png" alt="LawVo" className="h-8 w-8 object-contain sm:hidden" data-id="element-259" />
            </Link>
          </div>

          <nav className="hidden md:flex items-center gap-8" data-id="element-260">
            <a href="#features" className="text-sm font-medium text-primary hover:text-violetBlue transition-colors" data-id="element-261">
              Features
            </a>
            <a href="#how-it-works" className="text-sm font-medium text-primary hover:text-violetBlue transition-colors" data-id="element-262">
              How It Works
            </a>
            <div className="flex items-center gap-4" data-id="element-263">
              <Link to="/login" className="text-sm font-semibold text-violetBlue hover:text-primary transition-colors" data-id="element-264">
                Log In
              </Link>
              <Link to="/signup" className="px-5 py-2.5 bg-violetBlue text-white text-sm font-semibold rounded-lg hover:opacity-90 transition-opacity" data-id="element-265">
                Sign Up
              </Link>
            </div>
          </nav>

          <div className="md:hidden flex items-center" data-id="element-266">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="p-2 text-primary hover:bg-aliceBlue rounded-lg transition-colors" data-id="element-267">
              {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-268" /> : <Menu className="w-6 h-6" data-id="element-269" />}
            </button>
          </div>
        </div>
      </div>

      {isMobileMenuOpen && <div className="md:hidden bg-white border-t border-borderColor" data-id="element-270">
          <div className="px-4 pt-2 pb-4 space-y-1" data-id="element-271">
            <a href="#features" className="block px-3 py-2 text-base font-medium text-primary hover:bg-aliceBlue rounded-md" data-id="element-272">
              Features
            </a>
            <a href="#how-it-works" className="block px-3 py-2 text-base font-medium text-primary hover:bg-aliceBlue rounded-md" data-id="element-273">
              How It Works
            </a>
            <div className="mt-4 pt-4 border-t border-borderColor flex flex-col gap-3" data-id="element-274">
              <Link to="/login" className="block w-full text-center px-4 py-2.5 text-base font-semibold text-violetBlue border border-violetBlue rounded-lg hover:bg-aliceBlue transition-colors" data-id="element-275">
                Log In
              </Link>
              <Link to="/signup" className="block w-full text-center px-4 py-2.5 text-base font-semibold text-white bg-violetBlue rounded-lg hover:opacity-90 transition-opacity" data-id="element-276">
                Sign Up
              </Link>
            </div>
          </div>
        </div>}
    </header>;
}